import { render } from "./BRadio.vue?vue&type=template&id=412c3ec4"
import script from "./BRadio.vue?vue&type=script&lang=js"
export * from "./BRadio.vue?vue&type=script&lang=js"
script.render = render

export default script